module.exports = __webpack_public_path__ + "images/icons/agreement.svg?5524bed7ebab8ae213624f987326a467";